import { render, staticRenderFns } from "./disclaimer-flights-info.vue?vue&type=template&id=39602c3e&scoped=true"
import script from "./disclaimer-flights-info.vue?vue&type=script&lang=js"
export * from "./disclaimer-flights-info.vue?vue&type=script&lang=js"
import style0 from "./disclaimer-flights-info.vue?vue&type=style&index=0&id=39602c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39602c3e",
  null
  
)

export default component.exports